var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 27H15C14.072 26.999 13.1824 26.6299 12.5262 25.9738C11.8701 25.3176 11.501 24.428 11.5 23.5V17H21.0856L17.7931 20.2931C17.6135 20.4822 17.5148 20.7339 17.5182 20.9947C17.5215 21.2555 17.6266 21.5046 17.811 21.689C17.9954 21.8734 18.2445 21.9785 18.5053 21.9818C18.7661 21.9852 19.0178 21.8865 19.2069 21.7069L24.2069 16.7069C24.3943 16.5194 24.4995 16.2651 24.4995 16C24.4995 15.7349 24.3943 15.4806 24.2069 15.2931L19.2069 10.2931C19.0178 10.1135 18.7661 10.0148 18.5053 10.0182C18.2445 10.0215 17.9954 10.1266 17.811 10.311C17.6266 10.4954 17.5215 10.7445 17.5182 11.0053C17.5148 11.2661 17.6135 11.5178 17.7931 11.7069L21.0856 15H11.5V8.5C11.5 6.49688 13.6119 5 15.5 5H25C25.928 5.00099 26.8176 5.37006 27.4738 6.02622C28.1299 6.68238 28.499 7.57205 28.5 8.5V23.5C28.499 24.428 28.1299 25.3176 27.4738 25.9738C26.8176 26.6299 25.928 26.999 25 27ZM5.5 17C5.23478 17 4.98043 16.8946 4.79289 16.7071C4.60536 16.5196 4.5 16.2652 4.5 16C4.5 15.7348 4.60536 15.4804 4.79289 15.2929C4.98043 15.1054 5.23478 15 5.5 15H11.5V17H5.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow_.61121ae41a003870adac34927b2e5d02.svg";
export { ForwardRef as ReactComponent };